export const renderAirportCode = (iataCode, icaoCode) => {
  // If there's an IATA code, start with that
  let result = iataCode || "";

  // If there's an ICAO code
  if (icaoCode) {
    // If there was already an IATA code, append ICAO in parentheses
    if (iataCode) {
      result += ` (${icaoCode})`;
    } else {
      // If no IATA code, just use ICAO code
      result = icaoCode;
    }
  }

  return result;
};
export const airportCodeOnApprove = (iataCode, icaoCode) => {

  return iataCode ?? icaoCode ?? "";
};
export const calculateAge = (dateOfBirth) => {
  if (!dateOfBirth) {
    return "Invalid date";
  }

  const birthDate = new Date(dateOfBirth);
  const today = new Date();

  if (isNaN(birthDate.getTime()) || birthDate > today) {
    return "Invalid date";
  }

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }
  return age;
};

export const hasAirportAccess = (userData, airportData, targetAirportId) => {
  if (!userData?.data?.associations || !airportData || !targetAirportId) {
    return false;
  }

  return userData.data.associations.some(
    (association) => association.airportId === targetAirportId
  );
};

// Calculate number of nights between arrival and departure dates
export function calculateNightsCount(arrivalTime, departureTimeFromArrivalAirport) {
  if (!arrivalTime || !departureTimeFromArrivalAirport) {
    return 0;
  }

  const arrivalDate = new Date(arrivalTime);
  const departureDate = new Date(departureTimeFromArrivalAirport);

  // Normalize to only the UTC date (ignore time)
  const arrivalDay = Date.UTC(
    arrivalDate.getUTCFullYear(),
    arrivalDate.getUTCMonth(),
    arrivalDate.getUTCDate()
  );
  const departureDay = Date.UTC(
    departureDate.getUTCFullYear(),
    departureDate.getUTCMonth(),
    departureDate.getUTCDate()
  );

  const diffInMs = departureDay - arrivalDay;
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  return Math.max(0, diffInDays);
}

// Format amount to always display with two decimal places
export const formatAmount = (amount) => {
  return Number(amount).toFixed(2);
}
